import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ContactComponent } from './contact/contact.component';
import { PanchakrushnaComponent } from './panchakrushna/panchakrushna.component';
import { SongsComponent } from './songs/songs.component';
import { BooksComponent } from './books/books.component';
import { SmrutiComponent } from './smruti/smruti.component';
import { CharitraComponent } from './charitra/charitra.component';
import { SutrapathComponent } from './sutrapath/sutrapath.component';
import { ArtiComponent } from './arti/arti.component';
import { GallaryComponent } from './gallary/gallary.component';
import { SthanComponent } from './sthan/sthan.component';
import { AndroidComponent } from './android/android.component';
import { VideosComponent } from './videos/videos.component';
import { TncComponent } from './tnc/tnc.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { CopyrightsComponent } from './copyrights/copyrights.component';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SthandarshanComponent } from './sthandarshan/sthandarshan.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', component: HomeComponent },
  { path:'contact', component: ContactComponent },
  { path:'panchakrushna/:id', component: PanchakrushnaComponent  },
  { path:'gallary/songs', component: SongsComponent  },
  { path:'gallary/images', component: GallaryComponent  },
  { path:'sahitya/:type', component: BooksComponent  },
  { path:'smruti/:stype', component: SmrutiComponent  },
  { path:'path/sutrapath/:stype', component: SutrapathComponent  },
  { path:'path/arti/:atype', component: ArtiComponent  },
  { path:'charitra/lila/:ctype', component: CharitraComponent  },
  { path:'charitra/shriprabhu/:ctype', component: CharitraComponent  },
  { path:'charitra/:ctype', component: CharitraComponent  },
  { path:'sthan/:name', component: SthanComponent  },
  { path:'android/apps', component: AndroidComponent  },
  { path:'gallary/videos', component: VideosComponent  },
  { path:'policy/tnc', component: TncComponent  },
  { path:'policy/disclaimer', component: DisclaimerComponent  },
  { path:'policy/copyrights', component: CopyrightsComponent  },
  { path:'sthandarshan', component: SthandarshanComponent  },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false, scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]

})
export class AppRoutingModule { }
